import { useEffect, useRef } from 'react'
import { useBaiduMap } from './BaiduMap'

export interface BaiduCircleProps {
    center: { lat: number; lng: number }
    radius: number
    options?: {
        fillColor?: string
        fillOpacity?: number
        strokeColor?: string
        strokeOpacity?: number
        strokeWeight?: number
    }
}

const BaiduCircle: React.FC<BaiduCircleProps> = ({ center, radius, options }) => {
    const map = useBaiduMap()
    const circleRef = useRef<any>(null)

    useEffect(() => {
        if (!map || !window.BMapGL) return

        const point = new window.BMapGL.Point(center.lng, center.lat)
        const circle = new window.BMapGL.Circle(point, radius, {
            fillColor: options?.fillColor || '#78bfffcc',
            fillOpacity: options?.fillOpacity ?? 0.3,
            strokeColor: options?.strokeColor || '#78bfffcc',
            strokeWeight: options?.strokeWeight ?? 1,
            strokeOpacity: options?.strokeOpacity ?? 1,
        })

        map.addOverlay(circle)
        circleRef.current = circle

        return () => {
            map.removeOverlay(circle)
            circleRef.current = null
        }
    }, [map, center.lat, center.lng, radius, options?.fillColor, options?.fillOpacity, options?.strokeColor, options?.strokeWeight, options?.strokeOpacity])

    return null
}

export default BaiduCircle
